import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled || menuOpen
          ? 'bg-[#FAF7F2]/95 backdrop-blur-md shadow-sm border-b border-[#C9A96E]/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-center justify-between h-20 py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/6289f550e75cfa8e096b6d5be03ad3c7/ad8438fb476efc73746cd771a67dd6a9.png"
              alt="North Star ADHD Psychiatry for Women"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation Links */}
          <div className="hidden lg:flex items-center gap-10">
            <Link
              to="/adhd-evaluations"
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-[#1E2D5E] hover:text-[#C9A96E]' : 'text-[#FAF7F2] hover:text-[#F5C7B8]'
              }`}
            >
              ADHD Evaluations
            </Link>
            <Link
              to="/membership"
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-[#1E2D5E] hover:text-[#C9A96E]' : 'text-[#FAF7F2] hover:text-[#F5C7B8]'
              }`}
            >
              Membership
            </Link>
            <Link
              to="/coaching"
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-[#1E2D5E] hover:text-[#C9A96E]' : 'text-[#FAF7F2] hover:text-[#F5C7B8]'
              }`}
            >
              Coaching
            </Link>
            <Link
              to="/meet-lauren"
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-[#1E2D5E] hover:text-[#C9A96E]' : 'text-[#FAF7F2] hover:text-[#F5C7B8]'
              }`}
            >
              Meet Lauren
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-[#1E2D5E] hover:text-[#C9A96E]' : 'text-[#FAF7F2] hover:text-[#F5C7B8]'
              }`}
            >
              Contact
            </Link>
          </div>

          {/* Desktop CTA Button */}
          <Link
            to="/book-appointment"
            className={`hidden lg:inline-flex px-7 py-3 rounded-full text-sm font-medium tracking-wide transition-all duration-300 whitespace-nowrap cursor-pointer border ${
              isScrolled
                ? 'bg-[#1E2D5E] text-[#FAF7F2] border-[#1E2D5E] hover:bg-[#2A3F7A]'
                : 'bg-[#FAF7F2]/15 backdrop-blur-sm text-[#FAF7F2] border-[#FAF7F2]/50 hover:bg-[#FAF7F2]/25'
            }`}
          >
            Start with Clarity
          </Link>

          {/* Mobile Hamburger */}
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i
              className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'} ${
                isScrolled || menuOpen ? 'text-[#1E2D5E]' : 'text-[#FAF7F2]'
              }`}
            />
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {menuOpen && (
        <div className="lg:hidden bg-[#FAF7F2] border-t border-[#C9A96E]/20 px-5 py-6 flex flex-col gap-5">
          {[
            { label: 'ADHD Evaluations', to: '/adhd-evaluations' },
            { label: 'Membership', to: '/membership' },
            { label: 'Coaching', to: '/coaching' },
            { label: 'Meet Lauren', to: '/meet-lauren' },
            { label: 'Contact', to: '/contact' },
          ].map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className="text-base font-medium text-[#1E2D5E] hover:text-[#C9A96E] transition-colors duration-300 cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/book-appointment"
            onClick={() => setMenuOpen(false)}
            className="mt-2 px-7 py-3 rounded-full text-sm font-medium text-center bg-[#1E2D5E] text-[#FAF7F2] whitespace-nowrap cursor-pointer"
          >
            Book Appointment
          </Link>
        </div>
      )}
    </nav>
  );
}
